// External
import 'raf/polyfill';
import React from 'react';
import { render } from 'react-dom';

// Internal
import '../config/polyfills';

import App from './App';

const appRoot = document.getElementById('app-host');

render(<App />, appRoot);
